import Load from 'components/Load';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import React from 'react';
import { Route } from 'react-router-dom';
import basePath from 'utils/basePath';
import { isCordova } from 'utils/platform';

const HostOnboardingOriginalsContainer = Load(
  () =>
    import(
      /* webpackChunkName: "host-onboarding" */ './pages/HostOnboardingOriginals'
    ),
);
const HostOnboardingJoinContainer = Load(
  () =>
    import(
      /* webpackChunkName: "host-onboarding" */ './pages/HostOnboardingJoin'
    ),
);
const HostOnboardingFeedbackContainer = Load(
  () =>
    import(
      /* webpackChunkName: "host-onboarding" */ './pages/HostOnboardingFeedback'
    ),
);

const HostOnboardingPageRoute = () => {
  return [
    <NavigationableLayout
      key="host-onboarding-originals-join"
      path={`${basePath}/host/onboarding/withlocals-originals/:tier/join`}
      hideFooter
      component={HostOnboardingJoinContainer}
      showBottomNavigation
      noNavbar={isCordova()}
      nonFixedNavbar
    />,
    <NavigationableLayout
      key="host-onboarding-originals"
      path={`${basePath}/host/onboarding/withlocals-originals`}
      hideFooter
      component={HostOnboardingOriginalsContainer}
      showBottomNavigation
      noNavbar={isCordova()}
      nonFixedNavbar
    />,
    <NavigationableLayout
      key="host-onboarding-feedback"
      path={`${basePath}/host/onboarding/feedback`}
      hideFooter
      component={HostOnboardingFeedbackContainer}
      showBottomNavigation
      noNavbar={isCordova()}
      nonFixedNavbar
    />,
    <Route
      key={'host-onboarding'}
      path={`${basePath}/host/onboarding`}
      component={() => {
        window.location.replace(`${BECOME_A_HOST_HOST}/overview`);
        return null;
      }}
    />,
  ];
};
export default HostOnboardingPageRoute();
